import type { PermitListResponse } from '@contracts/permitSearch/PermitListResponse';
import { useToast } from '@src/common/hooks/useToast';
import type { SearchPermitForReportFilters } from '@src/permits/services/PermitApplicationClient';
import { PermitApplicationClient } from '@src/permits/services/PermitApplicationClient';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useSearchPermitsWithFees = () => {
  const [permits, setPermits] = useState<PermitListResponse | undefined>();
  const { t } = useTranslation();
  const { showErrorToast } = useToast();

  const { mutate: searchPermits, isPending } = useMutation({
    mutationFn: (filters: SearchPermitForReportFilters) =>
      PermitApplicationClient.searchPermitsWithFees(filters),
    onSuccess: (response: PermitListResponse) => {
      setPermits(response);
    },
    onError: () => showErrorToast(t('permitSearch.error')),
  });

  return {
    searchPermits,
    permits,
    isLoading: isPending,
  };
};
